const baseUrl = process.env.NODE_ENV === "development" ? "http://localhost:8045" : "https://ors-survey.theobjects.com";

const config = {
    baseUrl: baseUrl,
    serverUrl: `${baseUrl}/insert_licence_request`,
};

export default config;
